define('setup/configurators/configurator-factory',['require','setup/configurators/general-wf-configurator','setup/configurators/trial-wf-configurator','setup/configurators/free-trial-wf-configurator','lodash'],function (require) {
    var GeneralWorkflow = require('setup/configurators/general-wf-configurator');
    var TrialWorkflow = require('setup/configurators/trial-wf-configurator');
    var FreeTrialWorkFlow = require('setup/configurators/free-trial-wf-configurator');
    var _ = require('lodash');

    var tierMap = {
        // general workflow is the one used for paid accounts (direct buy, offline buy, voip only, etc)
        general: GeneralWorkflow,

        // pro trial accounts should follow this workflow
        trial: TrialWorkflow,

        // free but trial users should follow this workflow
        freeTrial: FreeTrialWorkFlow
    };

    // convert a set of settings/feature flags into
    // a tier name to construct the configurator
    function getWorkflowName(config) {
        if (config.isFreeTrial) { // free but trial user
            return 'freeTrial';
        } else if (config.isTrial) { // trial user
            return 'trial';
        }
        // paid user
        return 'general';
    }

    return {
        getInstance: function (config) {
            var tier = getWorkflowName(config);

            if (!tierMap[tier]) {
                throw new Error('Tier configuration does not exists');
            }

            var options = {
                // account level settings
                isTollFreeProvisioned: _.get(config, 'productSettings.tollFreeProvisioned'),
                isTollFreeAccessible: _.get(config, 'productSettings.tollFreeAccessible'),
                isTollFreeEnabled: _.get(config, 'productSettings.tollFreeEnabled'),
                adminAudioOnboardingViewed: _.get(config, 'settings.adminAudioOnboardingViewed'),

                // user level settings
                userTollFreeProvisioned: _.contains(_.get(config, 'settings.audio.allowedModes'), 'TOLLFREE'),
                userTollProvisioned: _.contains(_.get(config, 'settings.audio.allowedModes'), 'TOLL'),
                isAdmin: config.isAdmin,
                canManageSettings: config.isAdmin && config.canManageSettings,

                completeUrl: '#',

                goToMeetMeDown: !!config.goToMeetMeDown,
                extAdminDown: !!config.extAdminDown,

                reserveOnly: config.reserveOnly,
                isG2MMSchedulingTest: config.isG2MMSchedulingTest
            };

            return new tierMap[tier](options);
        }
    };
});

